/** */
import { urls } from 'services/_url';
import { apiGet, apiPost, apiPut } from 'services/_http';

/** */
const base_url = `${urls.agents}/v1/config/lead-gen`;

export const create = async (options = {}) => {
  return await apiPost(`${base_url}`, { ...options });
};

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const update = async (options = {}) => {
  return await apiPut(`${base_url}`, { ...options });
};
